import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const InputField = ({
  type,
  label,
  name,
  rules,
  value,
  onChange = () => null,
  hasOnChange = false,
  textarea = false,
  convertToLatin = false,
}) => {
  const convertPersianToLatinNumber = (persianNumber) => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const latinDigits = "0123456789";
    let latinNumber = "";

    for (let char of persianNumber) {
      const index = persianDigits.indexOf(char);
      if (index !== -1) {
        latinNumber += latinDigits[index];
      } else {
        latinNumber += char; // If the character is not a Persian digit, keep it as is
      }
    }

    return latinNumber;
  };
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className={" text-right mb-5 flex-1"}>
        <label className={"block text-md font-medium text-gray-800"}>
          {label}
          <div className="flex gap-2">
            <div className="flex flex-1 gap-1">
              <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={value}
                render={({ field }) => (
                  <>
                    {convertToLatin ? (
                      <input
                        className={
                          "w-full rounded border-0 bg-white px-3 py-3 text-md text-gray-600 placeholder-gray-300 shadow shadow-gray-400 transition-all duration-150 ease-linear focus:outline-none focus:ring"
                          /* `${disabled && 'cursor-not-allowed !bg-gray-200'}`,
     className, `${error && 'ring-red-300'}` */
                        }
                        id={name}
                        {...field}
                        type={type}
                        value={value}
                        onChange={(e) => {
                          const latinNumber = convertPersianToLatinNumber(
                            e.target.value
                          );
                          field.onChange(latinNumber);
                        }}
                      />
                    ) : (
                      <>
                        {!textarea ? (
                          hasOnChange ? (
                            <input
                              className={
                                "w-full rounded border-0 bg-white px-3 py-3 text-md text-gray-600 placeholder-gray-300 shadow shadow-gray-400 transition-all duration-150 ease-linear focus:outline-none focus:ring"
                                /* `${disabled && 'cursor-not-allowed !bg-gray-200'}`,
             className, `${error && 'ring-red-300'}` */
                              }
                              id={name}
                              {...field}
                              type={type}
                              value={value}
                              onChange={(e) => {
                                field.onChange(e);
                                onChange(e);
                              }}
                            />
                          ) : (
                            <input
                              className={
                                "w-full rounded border-0 bg-white px-3 py-3 text-md text-gray-600 placeholder-gray-300 shadow shadow-gray-400 transition-all duration-150 ease-linear focus:outline-none focus:ring"
                                /* `${disabled && 'cursor-not-allowed !bg-gray-200'}`,
           className, `${error && 'ring-red-300'}` */
                              }
                              id={name}
                              {...field}
                              type={type}
                              value={value}
                            />
                          )
                        ) : (
                          <textarea
                            className={
                              "w-full rounded border-0 bg-white px-3 py-3 text-md text-gray-600 placeholder-gray-300 shadow shadow-gray-400 transition-all duration-150 ease-linear focus:outline-none focus:ring"
                              /* `${disabled && 'cursor-not-allowed !bg-gray-200'}`,
             className, `${error && 'ring-red-300'}` */
                            }
                            id={name}
                            {...field}
                            type={type}
                            value={value}
                            onChange={(e) => {
                              field.onChange(e);
                              onChange(e);
                            }}
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </label>
        {errors[name]?.message && (
          <div
            role="alert"
            aria-label={errors[name].message}
            className="mt-1 text-sm font-semibold text-red-500"
          >
            {errors[name].message}
          </div>
        )}
        {/* <p className="mt-1 text-xs text-gray-500">{description}</p> */}
      </div>
    </div>
  );
};

export default InputField;
